module.exports = ".d-inline-block a {\n  font-size: 13px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/type3/type3.component.scss
// module id = ./src/app/components/type3/type3.component.scss
// module chunks = main